<template>
  <span>
    <span v-if="openid == 0">暂无</span>
    <ww-open-data v-else :type="type" :openid="openid" />
  </span>
</template>
<script>
export default {
  name: "openData",
  props: ["type", "openid"],
  watch: {
    openid(item) {
      this.$nextTick(() => {
        this.$WWOpenData.bind(this.$el);
      });
    },
  },
  mounted() {
    this.agentConfig();
  },
  methods: {
    agentConfig() {
      this.axios({
        url: "/crm/Index/getSignature1",
        method: "POST",
        data: {
          account_id: 437,
          url: `${window.location.href.split('#')[0]}`,
        },
      })
        .then((res) => {
          if (res.data.code == 1) {
            wx.agentConfig({
              corpid: res.data.data.appid, // 必填，企业微信的corpid，必须与当前登录的企业一致
              agentid: res.data.data.agent_id, // 必填，企业微信的应用id （e.g. 1000247）
              timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
              jsApiList: ["getAddressBook"], //必填，传入需要使用的接口名称
              success: function (result) {
                console.log(result, "请求微信成功");
                //  wx.agentConfig成功回调后，WWOpenData 才会注入到 window 对象上面
                this.$WWOpenData.bind(this.$el);
              },
              fail: function (res) {
                console.log(res);
                if (res.errMsg.indexOf("function not exist") > -1) {
                  alert("版本过低请升级");
                }
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
